import React from "react";

export default function Popup({ onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-gray-900 dark:bg-black opacity-60"></div>
      <div className="relative w-[30vw] bg-white-whiter dark:bg-dark-surface rounded-lg shadow-lg dark:shadow-dark-surface/20 p-6 text-center">
        <h2 className="text-2xl font-bold text-text dark:text-dark-text">Projeto em Desenvolvimento</h2>
        <p className="my-4 text-gray-600 dark:text-dark-textSecondary">
          Caso encontre algum bug ou tenha sugestões,<br/> entre em contato com o time de desenvolvimento<br/> pelo email: eng.processos@salexpress.com.br
        </p>
        <button
          onClick={onClose}
          className="bg-green-500 text-white-whiter font-bold text-xl py-2 px-8 rounded hover:bg-green-600 focus:outline-none"
        >
          Entendido
        </button>
      </div>
    </div>
  );
}
